import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.css";
import InputField from "./inputField";
import moment from "moment";

// registerLocale("ja", np as any);
interface Props {
  date: Date | string | null;
  setDate: (date: string) => unknown;
  label?: string;
  minDate?: Date | null;
  headerComponent?: React.ReactNode | null;
}
export const DateField = ({
  date,
  setDate,
  label = "Date",
  minDate = null,
  headerComponent = null,
}: Props) => {
  const CustomInput = ({ value, onClick }: any) => (
    <div>
      <InputField
        value={date as any}
        setValue={() => {}}
        isDateAndTime
        label={label}
        onClick={onClick}
        headerComponent={headerComponent}
      />
    </div>
  );

  return (
    <ReactDatePicker
      onChange={(date: Date) => {
        const formattedDate = moment(date).format("YYYY-MM-DD");
        setDate(formattedDate);
      }}
      customInput={<CustomInput />}
      className="date-picker"
      wrapperClassName="date-picker"
      calendarClassName="calendar"
      portalId="app-root"
      dateFormat={"yyyy/dd/MM"}
      minDate={minDate}
      showYearDropdown
      showMonthDropdown
      yearDropdownItemNumber={100}
      // dropdownMode="select"
    />
  );
};
